var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "188px",
    height: "73px",
    viewBox: "0 0 188 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u27A1\uFE0F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1.\\u55E8\\u5B66-\\u5FAE\\u4FE1\\u6253\\u5F00",
    transform: "translate(-435.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u27A1\\uFE0F",
    transform: "translate(435.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16722267,65.8505936 C19.6035433,68.8313076 31.8482391,70.2772823 38.9013102,70.1885175 C66.2120018,69.844805 83.99126,59.8194283 88.8820856,41.1697381 C90.9947637,33.1136765 84.0315394,25.8665082 78.2451827,24.2945085 C68.3528624,21.6070273 58.4162351,28.9875149 58.4162351,36.5712673 C57.8534581,50.0197558 69.6091749,56.8420094 90.5769991,56.8420094 C100.240809,56.8420094 118.43683,53.4186593 134.150741,45.462189 C141.139409,41.9235962 151.599601,34.264205 165.531316,22.4840154",
    id: "\\u8DEF\\u5F84",
    stroke: "#3377FF",
    strokeWidth: 3.64274777,
    strokeLinecap: "round",
    strokeDasharray: 6.819223582762163
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u4E09\\u89D2\\u5F62",
    fill: "#3377FF",
    transform: "translate(173.833087, 13.304405) rotate(-324.000000) translate(-173.833087, -13.304405) ",
    points: "173.861281 4.19753572 183.933362 22.4112746 163.732811 22.3702704"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.00a1d3ea208bacfecc416d40541662ee.svg";
export { ForwardRef as ReactComponent };